// 3rd-party modules
import { useEffect, useState } from "react";

// project modules
import { apiCall } from "../../helpers/apiHelper";
import { SellSummeryReportModel } from "../../models/sellSummeryReport";
import CustomChart from "../shared/chart/chart";

//apis
import * as ReportApi from '../../apis/reportApi';
import Loader from "../shared/loader";
import { formatMoney } from "../../helpers/objectHelper";
import useTranslation from "../../hooks/TranslationContext";
import { Radio, RadioChangeEvent, Typography } from "antd";
import { isMobile } from "react-device-detect";

export default function SellSummeryReport() {
  const { t } = useTranslation();

  const [period, setPeriod] = useState<number>(7);
  const [loading, setLoading] = useState(false);
  const [datasource, setDatasource] = useState<any[]>([]);
  const abortController = new AbortController();

  const chartOptions = {
    chart: {
      type: 'line',
      toolbar: { show: false },
      zoom: {
        enabled: false,
        // type: 'x',
        // autoScaleYaxis: false,
        // allowMouseWheelZoom: true,
        // zoomedArea: {
        //   fill: {
        //     color: '#90CAF9',
        //     opacity: 0.4
        //   },
        //   stroke: {
        //     color: '#0D47A1',
        //     opacity: 0.4,
        //     width: 1
        //   }
        // }
      }
    },
    // title: {
    //   text: t("sell-summary-report"),
    //   align: 'left'
    // },
    xaxis: {
      categories: datasource.map(x => x.date),
      title: { text: t("date") },
      labels: {
        rotate: -45, // Rotates labels counter-clockwise
        rotateAlways: true, // Ensures the rotation is always applied
        style: {
          fontSize: '12px',
          // fontWeight: 'bold',
        },
        tickAmount: 6, // Controls the number of visible labels
        formatter: (value: any) => {
          // Show every 2nd label for better readability
          const index = datasource.map(x => x.date).indexOf(value);
          // Show certain count of labels depends on period.
          let showingInterval = 1;
          if (period > 31) {
            showingInterval = 10;
          } else if (showingInterval > 7 && isMobile) {
            showingInterval = 3;
          }

          return index % showingInterval === 0 ? value : '';
        },
        // formatter: function(value: any, timestamp: any, opts: any) {
        //   console.log("value", value)
        //   console.log("timestamp", timestamp)
        //   console.log("opts", opts)
        // }
      },
    },
    yaxis: {
      title: { text: t("total-amount") },
      labels: {
        formatter: (value: any) => {
          return `${formatMoney(value / 10000000)}`;
        },
      },
    },
    dataLabels: {
      formatter: (value: any) => {
        return `${formatMoney(value / 10000000, "", "", 1)}`;
      },
    },
    tooltip: {
      y: {
        // Format tooltip values to 3 decimals
        formatter: (value: any) => {
          return formatMoney(value);
        },
      },
    },
  };

  const chartSeries = [
    {
      name: t("total-amount"),
      data: datasource.map(x => x.totalAmount),
    },
  ];

  useEffect(() => {
    getDataAsync();
  }, [period]);

  const getData = async (abortSignal?: AbortSignal) => {
    const response = await apiCall(ReportApi.getSellSummeryReport(period, abortSignal));

    return response.success ? SellSummeryReportModel.toArrayOfClass((response.data?.value || [])) : [];
  };

  const getDataAsync = async () => {
    setLoading(true);
    setDatasource(await getData(abortController.signal));
    setLoading(false);
  }

  const onPeriodChange = (e: RadioChangeEvent) => {
    setPeriod(e.target.value)
  };

  return (
    <>
      <Typography.Text strong>{t("sell-summary-report")}</Typography.Text>
      <div className="">
        <Radio.Group onChange={onPeriodChange} defaultValue="7">
          <Radio.Button value="1">1</Radio.Button>
          <Radio.Button value="3">3</Radio.Button>
          <Radio.Button value="7">7</Radio.Button>
          <Radio.Button value="30">30</Radio.Button>
          <Radio.Button value="90">90</Radio.Button>
        </Radio.Group>
      </div>
      {loading && <Loader />}
      {!loading &&
      <CustomChart
        options={chartOptions}
        series={chartSeries}
        type="line"
        height={250}
        width="100%"
      />}
    </>
  )
}
